import * as e from "react";
const t = (o) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 10", ...o }, /* @__PURE__ */ e.createElement("path", { stroke: "#222", strokeLinecap: "round", strokeLinejoin: "round", d: "M1.5 5.28 4.31 8.1l6.19-6.18", className: "chr-icon__stroke--dark" })), n = t;
export {
  n as T
};
